<template>
  <div :class="containerClasses">
      <SubscriptionBigNumber
          v-for="item in bigNumbers"
          :key="item.id"
          v-bind="item"
          class="snap-item mb-2"
      />
  </div>
</template>

<script>
import SubscriptionBigNumber from "@/components/shared/SubscriptionBigNumber.vue";

export default {
  name: "SubscriptionReportBigNumbers",
  components: {SubscriptionBigNumber},
  data() {
    return {
      bigNumbers: [
        {
          id: "totalSubscriptions",
          title: "Receita de assinaturas",
          subnumberDescription: "Vendas de assinaturas",
          tooltip: "Soma líquida das assinaturas com status Ativo ou Em trial, incluindo novas, recorrentes e conversões inteligentes. Reflete o valor atual, independente do período filtrado.",
          type: "info",
          loading: "totalLoading",
        },
        {
          id: "newSubscriptions",
          title: "Novas assinaturas pagas",
          subnumberDescription: "Vendas de assinaturas",
          tooltip: "Valor líquido de assinaturas com a primeira parcela foi paga dentro do período selecionado no filtro de data.",
          type: "info",
        },
        {
          id: "recurrentSubscriptions",
          title: "Assinaturas recorrentes",
          subnumberDescription: "já ativas",
          tooltip: "Valor líquido de assinaturas com segunda parcela ou mais pagas dentro do período selecionado.",
          type: "info",
        },
        {
          id: "toReceiveCurrentMonth",
          title: "Valor a receber no mês atual",
          subnumberDescription: "Vendas a receber",
          tooltip: "Total a vencer neste mês, considerando todas as assinaturas com vencimento no mês corrente. Não é afetado pelo filtro de data.",
          type: "info",
        },
        {
          id: "smartSales",
          title: "Vendas inteligentes",
          subnumberDescription: "vendas de assinaturas",
          tooltip: "Mostra a receita gerada por vendas facilitadas através do mecanismo de Venda Inteligente, permitindo que clientes sem limite disponível pudessem adquirir o produto.",
          type: "info",
        },
        // {
        //   id: "averageTicket",
        //   title: "Ticket médio",
        //   tooltip: "Indica o valor médio por cada compra de assinatura. Calculado pela fórmula: receita líquida/número de vendas.",
        //   type: "info",
        // },
        {
          id: "overdueSubscriptions",
          title: "Assinaturas em atraso",
          subnumberDescription: "Contratos de assinaturas",
          tooltip: "Soma dos valores de faturas vencidas e não pagas dentro do período filtrado.",
          type: "warning",
        },
        {
          id: "canceledSubscriptions",
          title: "Assinaturas canceladas",
          subnumberDescription: "assinaturas",
          tooltip: "Assinaturas canceladas ou reembolsadas durante o período selecionado no filtro.",
          type: "danger",
        },
      ],
    };
  },
  computed: {
    containerClasses() {
      if (window.innerWidth < 768) {
        return 'd-flex horizontal-scroll mb-4 pb-2 scroll-content gap-4';
      }
      return 'd-flex align-items-center flex-wrap gap-4 mb-4';
    },
  }

};
</script>

<style scoped>
.gap-4 {
  gap: 1rem;
}

.horizontal-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x mandatory;
}

.snap-item {
  scroll-snap-align: start;
}
</style>